import { Injectable } from '@angular/core';
import { GridLayoutService } from '@irb-common/interfaces/grid-layout.service';
import { DialogPortfolioMultieditViewComponent } from '@irb/irb-dialogs/dialog-portfolio-multiedit-view/dialog-portfolio-multiedit-view.component';
import { TruncateTooltipCellComponent } from '@irb-common/components/grid/renderers/truncatetooltip.cell.component';

@Injectable({
    providedIn: 'root'
})
export class DialogPortfolioMultieditViewGridLayoutService implements GridLayoutService<DialogPortfolioMultieditViewComponent> {
    constructor() {}

    getFrameworkComponents() {
        return {
            "TruncateTooltipCellComponent": TruncateTooltipCellComponent
        };
    }

    getColumnDefs(_parent: DialogPortfolioMultieditViewComponent) {
        return [
            {
                headerName: 'Name',
                field: 'portfolioName',
                suppressFiltersToolPanel: true,
                filter: 'agTextColumnFilter',
                suppressFloatingFilterButton: true,
                filterParams: {
                    clearButton: true,
                    debounceMs: 1000,
                    textFormatter: this.portfolioFilterFormatter,
                    suppressAndOrCondition: true,
                    values: (_params: any) => {
                        //params.success(parent.modelNames);
                    }
                },
                //pinned: 'left',
                suppressMovable: true,
                //lockPosition: true,
                //lockVisible: true,
                minWidth: 180,
                flex: 1
            },{
                headerName: 'Market Value',
                suppressFiltersToolPanel: true,
                field: 'totalPortfolioValue',
                cellRenderer: 'cellRendererFormatter',
                cellRendererParams: {type: 'currency'},
                floatingFilterComponent: 'irbInputFloatingFilterComponent',
                filter: 'irbAgNumberColumnFilterComponent',
                minWidth: 100,
                flex: 1
            },{
                headerName: 'Assigned Accounts',
                suppressFiltersToolPanel: true,
                field: 'acctQty',
                cellClass: "irb-cell-content-right",                
                floatingFilterComponent: 'irbInputFloatingFilterComponent',
                filter: 'irbAgNumberColumnFilterComponent',
                minWidth: 90,
                flex: 1
            }
        ];
    }

    portfolioFilterFormatter(filter: any) {
        if (filter === null) {
          return null;
        }
    
        return filter;
    }
}
